import { BYE } from "../../../publicFunctions/adminDuelHandler";
import "../../../styles/tournamentView.css";
import { useEffect, useState } from "react";
import {
  createLinesToNextMatch,
  getCellPosition,
  getCellSizeForLane,
  getCenteredObjectPosition,
  getNumberOfMatchesBottomBracket,
  getPseudoLaneNumber,
  getPseudoMatchNumber,
  getSizesForZoomLevel,
  isThisLaneLeftSide,
  numberOfMatchesForLane,
  TBD,
} from "../../../publicFunctions/publicHelpers/tournamentViewHelper";
import { addMatchToPayload } from "./addMatchToPayload";

function FSTournamentView({
  mutedUsers,
  finalShowdownFromServer,
  storyListFromServer,
  cardImageUrl,
  genreText,
  nightMode,
  debriefMeta,
}) {
  const [zoomLevel, setZoomLevel] = useState(1);
  const [finalShowdown, setFinalShowdown] = useState(null);
  const [renderedView, setRenderedView] = useState(null);

  // create the working finalShowdown object.
  // If there is no round 2, then we need to create round 2 for
  // matches with Byes in round 1
  useEffect(() => {
    if (
      finalShowdownFromServer?.totalRounds &&
      storyListFromServer?.length &&
      debriefMeta
    ) {
      const tempStoryMap = new Map();
      for (let i = 0; i < storyListFromServer.length; i++) {
        const story = storyListFromServer[i];
        tempStoryMap.set(story.storyId, story);
      }

      const houseIdToHouseInfo = new Map();
      for (let i = 1; i <= 4; i++) {
        const houseForThisGenre = debriefMeta.houses["genre" + i.toString(10)];
        for (let j = 0; j < houseForThisGenre.length; j++) {
          const house = houseForThisGenre[j];
          houseIdToHouseInfo.set(house.houseId, house);
        }
      }

      const totalRounds = finalShowdownFromServer.totalRounds;
      const sizes = getSizesForZoomLevel(zoomLevel, totalRounds);
      // create arrayOfArray for the lanes and matches
      const lanes = [];
      const numberOfLanes = sizes.numberOfLanes;
      for (let lane = 1; lane <= numberOfLanes; lane++) {
        const matches = [];
        const numMatchForLane = numberOfMatchesForLane(
          lane,
          totalRounds,
          getNumberOfMatchesBottomBracket(totalRounds),
          numberOfLanes
        );
        for (let j = 0; j < numMatchForLane; j++) {
          matches.push({
            topScore: 0,
            topStoryId: TBD,
            topScore: 0,
            bottomStoryId: TBD,
            bottomScore: 0,
            winner: "",
          });
        }
        lanes.push(matches);
      }

      const projectedRound2 = [];
      // We need to create a projected round 2 if there are Byes
      if (finalShowdownFromServer.currentRound === 0) {
        const round1 = finalShowdownFromServer.rounds.round1;
        for (let i = 0; round1 && i < round1.length; i += 2) {
          const matchLeft = round1[i];
          const matchRight = round1[i + 1];

          let leftStoryId = "";
          if (matchLeft.leftStoryId === BYE) {
            leftStoryId = matchLeft.rightStoryId;
          } else if (matchLeft.rightStoryId === BYE) {
            leftStoryId = matchLeft.leftStoryId;
          }
          let rightStoryId = "";
          if (matchRight.leftStoryId === BYE) {
            rightStoryId = matchRight.rightStoryId;
          } else if (matchRight.rightStoryId === BYE) {
            rightStoryId = matchRight.leftStoryId;
          }
          projectedRound2.push({
            leftStoryId,
            rightStoryId,
            leftScore: 0,
            rightScore: 0,
            winner: "",
          });
        }
      }

      for (let i = 1; i <= totalRounds; i++) {
        let round;
        if (i <= finalShowdownFromServer.currentRound + 1) {
          round = finalShowdownFromServer.rounds["round" + i.toString(10)];
        } else if (i === 2 && projectedRound2?.length) {
          round = projectedRound2;
        } else {
          break;
        }
        if (!round) {
          break;
        }

        // Okay, we have a round!
        for (
          let realMatchIndex = 0;
          realMatchIndex < round.length;
          realMatchIndex++
        ) {
          let leftIsTop = realMatchIndex < Math.round(round.length / 2);
          const pseudoLane = getPseudoLaneNumber(leftIsTop, i, totalRounds);

          const laneIndexToUse = pseudoLane - 1;
          const numMatchesLane = numberOfMatchesForLane(
            pseudoLane,
            totalRounds,
            sizes.numberOfMatchesBottomBracket,
            sizes.numberOfLanes
          );
          const matchIndexToUse = getPseudoMatchNumber(
            leftIsTop,
            realMatchIndex,
            numMatchesLane,
            round.length,
            totalRounds % 2 !== 0
          );

          const matchFromServer = round[realMatchIndex];
          const match = lanes[laneIndexToUse][matchIndexToUse];
          if (!match) {
            // console.log(lanes[laneIndexToUse]);
            // console.log(matchFromServer);
            // console.log("index " + j);
            // console.log("numMatchesLane " + numMatchesLane);
            // console.log("laneIndexToUse " + laneIndexToUse);
            // console.log("matchIndexToUse " + matchIndexToUse);
            // console.log("pseudoLane " + pseudoLane);
          }

          if (i === totalRounds) {
            // center
            leftIsTop = true;
          }

          match.topScore = leftIsTop
            ? matchFromServer.leftScore
            : matchFromServer.rightScore;
          match.bottomScore = leftIsTop
            ? matchFromServer.rightScore
            : matchFromServer.leftScore;
          match.topStoryId = leftIsTop
            ? matchFromServer.leftStoryId
            : matchFromServer.rightStoryId;
          match.bottomStoryId = leftIsTop
            ? matchFromServer.rightStoryId
            : matchFromServer.leftStoryId;
          match.winner = matchFromServer.winner;
        }
      }

      setFinalShowdown({
        storyMap: tempStoryMap,
        sizes,
        lanes,
        houseIdToHouseInfo,
      });
    }
  }, [finalShowdownFromServer, storyListFromServer, debriefMeta]);

  // now that we have the finalShowdown object, we should render it
  useEffect(() => {
    if (finalShowdown) {
      const sizes = finalShowdown.sizes;
      const tempPayload = [];
      const matchBoxClass = nightMode ? "matchBox--white" : "matchBox";

      // Create cells
      for (let lane = 1; lane <= finalShowdown.sizes.numberOfLanes; lane++) {
        const numOfMatches = numberOfMatchesForLane(
          lane,
          sizes.totalRounds,
          sizes.numberOfMatchesBottomBracket,
          sizes.numberOfLanes
        );
        const cellSize = getCellSizeForLane(sizes, numOfMatches);

        let redOrBlue = 1;
        for (let row = 0; row < numOfMatches; row++, redOrBlue *= -1) {
          const cellPos = getCellPosition(cellSize, row, lane);
          const colorToUse =
            redOrBlue === 1 ? "rgba(255, 0, 0, 0.1)" : "rgba(0, 0, 255, 0.1)";
          const match = finalShowdown.lanes[lane - 1][row];
          // tempPayload.push(
          //   <div
          //     style={{
          //       position: "absolute",
          //       width: cellSize.w.toString(10) + "px",
          //       height: cellSize.h.toString(10) + "px",
          //       top: cellPos.y,
          //       left: cellPos.x,
          //       backgroundColor: colorToUse,
          //       zIndex: 0,
          //     }}
          //     className={matchBoxClass}
          //     key={"testing123_" + lane.toString(10) + "_" + row.toString(10)}
          //   ></div>
          // );

          // actual match
          const centeredMatchPos = getCenteredObjectPosition(
            cellPos,
            cellSize,
            sizes.matchBoxW,
            sizes.matchBoxH
          );

          // START OF LINES ********************
          const isLaneOnLeft = isThisLaneLeftSide(lane, sizes.numberOfLanes);
          if (lane !== Math.ceil(sizes.numberOfLanes / 2)) {
            // next match lookahead
            const nextCellSize = getCellSizeForLane(
              sizes,
              numberOfMatchesForLane(
                isLaneOnLeft ? lane + 1 : lane - 1,
                sizes.totalRounds,
                sizes.numberOfMatchesBottomBracket,
                sizes.numberOfLanes
              )
            );
            const centeredNextMatchPos = getCenteredObjectPosition(
              getCellPosition(
                nextCellSize,
                Math.floor(row / 2),
                isLaneOnLeft ? lane + 1 : lane - 1
              ),
              nextCellSize,
              sizes.matchBoxW,
              sizes.matchBoxH
            );

            // create lines
            createLinesToNextMatch(
              centeredMatchPos,
              centeredNextMatchPos,
              sizes,
              tempPayload,
              isLaneOnLeft,
              row % 2 === 0 &&
                Math.floor((sizes.numberOfLanes + 1) / 2) !== lane - 1,
              nightMode
            );
          }
          // END OF LINES ***************************

          // MATCH
          addMatchToPayload(
            finalShowdown,
            tempPayload,
            sizes,
            match,
            centeredMatchPos,
            lane,
            row,
            zoomLevel,
            matchBoxClass,
            nightMode,
            mutedUsers,
            isLaneOnLeft,
            debriefMeta.battleId
          );
        }
      }

      setRenderedView(
        <div
          style={{
            position: "relative",
            width: sizes.screenSizeW.toString(10) + "px",
            height: sizes.screenSizeH.toString(10) + "px",
          }}
        >
          {tempPayload}
        </div>
      );
    }
  }, [finalShowdown, zoomLevel, nightMode]);

  return (
    <div
      className={
        "tournament-viewer" + (nightMode ? " tournament-viewer--white" : "")
      }
    >
      {renderedView}
    </div>
  );
}

export default FSTournamentView;
